import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, Location } from "react-router-dom";
import * as Mui from "@mui/material";
import "../component/grossDemandDetermination.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GenericFilterBox from "./common/GenericFilterBox";
import { ContextOperation } from "../context/OperationContext";
import { grossDemandActions } from "../service/grossdemand.actions";
import { AutoCompleteOption } from "./common/AutoComplete";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useHasScope } from "../../../config/globalConfig";

const TitleNavigation: any = (props:any) => {
  const hasScope = useHasScope;
  const userDemand = grossDemandActions();
  const location = useLocation();
  const { t } = useTranslation(["operation"]);
  const totalDemand = "Total Demand";
  const tabOnePathname ="/operation/planning/gross"
  const tabTwoPathname ="/operation/planning/carsegment"
  const tabThreePathname ="/operation/planning/carsupply"
  const { tenant } = useContext(ContextOperation);
  const [allAggregations, setAllAggregations] = useState<any>([]);
  const [selectedAggregation, setSelectedAggregation] = useState<any>(totalDemand);
  // const [startDate, setStartDate] = useState<Dayjs | null >(null);
  // const [endDate, setEndDate] = useState<Dayjs | null>(null );
  const [dataFormTabThree, setDataFormTabThree] = useState<any>({
    startDate: null,
    endDate: null
  })
 
  
  function convertMainTitle(mainType: any) {
    let mainTitleString = "";
    function titleCase(str: any) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      mainTitleString = splitStr.join(" ");
      return mainTitleString;
    }
    titleCase(mainType);
    switch (mainType) {
      case "":
        return (mainTitleString = "");
      default:
        return mainTitleString;
    }
  }
  async function getFilter() {
    userDemand
    .getAggregations(tenant)
    .then((response: any) => {
      setAllAggregations(response);
      setSelectedAggregation(response[0]);
    })
    .catch((error: any) => {
      console.log("error", error);
    });

   
  }
  useEffect(() => {
    
    userDemand
    .getAggregations(tenant)
    .then((response: any) => {
      setAllAggregations(response);
      props.setDataSearchFormOne(response[0])
      setSelectedAggregation(response[0]);
    })
    //props.setTenant(tenant)
    //props.setDataSearchFormOne(selectedAggregation)
      //getFilter();

    }, [tenant]);

    const onSearch = (e:any) =>
    {
     e.preventDefault()
      switch (location.pathname) {
          case tabOnePathname:
              props.setDataSearchFormOne(selectedAggregation)
              props.setRefreshButton(!props.refreshButton)
              break
          case tabTwoPathname:
             
              props.setRefreshButton(!props.refreshButton)
              break
          case tabThreePathname:
              props.setDataSearchFormThree(dataFormTabThree)
              props.setRefreshButton(!props.refreshButton)
              break      
      
  
    }
      return
    }

    const onResetFilter = () =>{
      //props.setTenant(tenant)
        switch (location.pathname) {
            case tabOnePathname:
                
                setSelectedAggregation(allAggregations[0])
                props.setDataSearchFormOne(allAggregations[0])
                props.setRefreshButton(!props.refreshButton)
                break
            case tabTwoPathname:
                props.setRefreshButton(!props.refreshButton)
                break
            case tabThreePathname:
                setDataFormTabThree({
                  startDate: null,
                  endDate: null
                })
                props.setDataSearchFormThree(null)
                props.setRefreshButton(!props.refreshButton)
                break      
        }
        return
      }
  return (
    <>
   <form id="idFleetPlanningList" onSubmit={(e) => onSearch(e)}>
    <GenericFilterBox formId="idFleetPlanningList" onReset={onResetFilter}>
      {(location.pathname === tabOnePathname) && <>
        <Mui.Autocomplete
          disablePortal
          disableClearable
          id="aggregation"
          value={selectedAggregation}
          options={allAggregations.map((response:any) =>  response)}
          getOptionLabel={(option) => convertMainTitle(option)}
          onChange={(e, value) => setSelectedAggregation(value)}
          renderInput={(params:any) => <Mui.TextField fullWidth variant="standard"
          {...params}
          label={t("fleetPlanning.grossDemandDetermination.aggregation")} />}
          renderOption={(props, option, state) => {
            return (
              <li {...props} key={props.id}>
                {option}
              </li>
            )
          }}
        />
      </>}
      {location.pathname === tabTwoPathname && <></>}
      {location.pathname === tabThreePathname && <>
        <DatePicker
                  views={["year", "month"]}
                  label={t(
                    "fleetPlanning.carSegmentSupplyDetermination.startDate"
                  )}
                  value={dataFormTabThree.startDate}
                      onChange={(e) => {
                          setDataFormTabThree({
                            ...dataFormTabThree,
                            startDate: e
                      })
                    }}
                  maxDate={dataFormTabThree.endDate}
                  minDate={dataFormTabThree.endDate? dayjs(dataFormTabThree.endDate).subtract(11,'months'): null}
                  renderInput={(params) => (
                    <Mui.TextField variant="standard" {...params} fullWidth  />
                  )}
                />
        <DatePicker
                  views={["year", "month"]}
                  label={t(
                    "fleetPlanning.carSegmentSupplyDetermination.endDate"
                  )}
                  //value={endDate}
                  // InputProps={{
                  //   endAdornment: (
                  //     <DateRangeIcon sx={{ width: "18px", height: "18px" }} />
                  //   ),
                  // }}
                 
                  value={dataFormTabThree.endDate}
                      onChange={(e) => {
                          setDataFormTabThree({
                            ...dataFormTabThree,
                            endDate: e
                      })
                    }}
                  minDate={dataFormTabThree.startDate}
                  maxDate={dataFormTabThree.startDate? dayjs(dataFormTabThree.startDate).add(11,'months'): null}
                  renderInput={(params) => (
                    <Mui.TextField variant="standard" fullWidth {...params} />
                  )}
                />
      </>}
    </GenericFilterBox>
    </form>
    <Mui.Box component={"div"} pl={2} pr={2}  >
    <Mui.Tabs
    sx={{boxShadow: '0px -4px 0px rgba(151, 151, 151, 0.2) inset',  }}
      TabIndicatorProps={{
        sx: {
          height: "5px",
          backgroundColor: "rgba(200, 1, 125, 1)",
          

        },
      }}
      value={location.pathname}
      aria-label="basic tabs example"
    >
      {hasScope("SCOPE_MANAGE_GDD_PLANNING") && (
      <Mui.Tab
        to={tabOnePathname}
        component={Link}
        label={
          <div>
            <Mui.Typography >
            {t("fleetPlanning.grossDemandTitle")}
            </Mui.Typography>
          </div>
        }
        value={tabOnePathname}
      ></Mui.Tab>
      )}
      {hasScope("SCOPE_MANAGE_CSD_PLANNING") && (
      <Mui.Tab
        to={tabTwoPathname}
        component={Link}
        label={
          <div>
            <Mui.Typography >
            {t("fleetPlanning.carSegmentDemandTitle")}
            </Mui.Typography>
          </div>
        }
        value={tabTwoPathname}
      ></Mui.Tab>
      )}
      {hasScope("SCOPE_MANAGE_CSS_PLANNING") && (
      <Mui.Tab
        to={tabThreePathname}
        component={Link}
        label={
          <div>
            <Mui.Typography >
            {t("fleetPlanning.carSegmentSupplyTitle")}
            </Mui.Typography>
          </div>
        }
        value={tabThreePathname}
      ></Mui.Tab>
      )}
    </Mui.Tabs>
  </Mui.Box> 
  </>
  );
};
export default TitleNavigation;
